import gql from "graphql-tag";

const LanguageQueries = {
  GET_LANGUAGE: gql`
    {
      language @client
    }
  `,
  GET_DIRECTION: gql`
    {
      direction @client
    }
  `
};

export default LanguageQueries;
